import { render, staticRenderFns } from "./statement.vue?vue&type=template&id=8ed52d8c&scoped=true"
import script from "./statement.vue?vue&type=script&lang=js"
export * from "./statement.vue?vue&type=script&lang=js"
import style0 from "./statement.vue?vue&type=style&index=0&id=8ed52d8c&prod&scoped=true&lang=css"
import style1 from "./statement.vue?vue&type=style&index=1&id=8ed52d8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed52d8c",
  null
  
)

export default component.exports